export default {
    namespaced: true,
    state: {
        defaultLayout: [
            'dashboard',
            'tasks',
            'startups',
            'searches',
            'categories',
            'trending',
            'applied',
        ],
    },
    mutations: {
        changeLayout(state, layout) {
            this.state.user.settings.homepage = layout
        },
    },
    getters: {
        layout: (state, getters, rootState) => {
            if (rootState.user.id && rootState.user.settings.homepage === null) {
                if (rootState.accountType === 'free') {
                    rootState.user.settings.homepage = state.defaultLayout.filter(item => !['searches','tasks','categories','trending','applied'].includes(item))
                } else if (rootState.user.settings.disable_tasks) {
                    rootState.user.settings.homepage = state.defaultLayout.filter(item => !['tasks'].includes(item))
                } else {
                    rootState.user.settings.homepage = [...state.defaultLayout]
                }
            }

            return rootState.user.settings.homepage
        },
    },
}
